import { useState } from 'react';
import { useMutation } from '@apollo/client/react';

import { MEDIA_UPDATE } from '@atom/graph/media';

const SAVE_ERROR = 'Could not save your change. Please try again.';

type MediaUpdateFields = {
  name?: string;
  description?: string;
  capturedDate?: number;
};

export type MediaUpdateState = {
  save: (fields: MediaUpdateFields) => Promise<boolean>;
  saving: boolean;
  saveError: string;
  reset: () => void;
};

const useMediaUpdate = (mediaId: string): MediaUpdateState => {
  const [saving, setSaving] = useState<boolean>(false);
  const [saveError, setSaveError] = useState<string>(null);

  const [mediaUpdate] = useMutation(MEDIA_UPDATE);

  const save = async (fields: MediaUpdateFields): Promise<boolean> => {
    setSaving(true);
    setSaveError(null);

    try {
      await mediaUpdate({ variables: { input: { id: mediaId, ...fields } } });
      return true;
    } catch {
      setSaveError(SAVE_ERROR);
      return false;
    } finally {
      setSaving(false);
    }
  };

  const reset = () => {
    setSaving(false);
    setSaveError(null);
  };

  return { save, saving, saveError, reset };
};

export default useMediaUpdate;
